import React, { useEffect } from 'react';
import { ArrowLeft } from 'lucide-react';
import type { CurrentPage } from '../../App';

interface RirPlanProps {
  onNavigate: (page: CurrentPage, associatedId?: string) => void;
  floorPlanId?: string;
}

const RirPlan: React.FC<RirPlanProps> = ({ onNavigate, floorPlanId }) => {
  useEffect(() => {
    if (floorPlanId) {
      console.log('RirPlan received floorPlanId:', floorPlanId);
      // Logic to load/use RIR plan for this floorPlanId
    }
  }, [floorPlanId]);

  return (
    <div className="min-h-screen bg-white flex flex-col">
      {/* Header */}
      <header
        className="bg-gray-100 border-b border-gray-200 shadow-sm sticky top-0 z-40 flex-shrink-0"
      >
        <div className="w-full px-4 py-3 flex items-center justify-between">
          <button
            onClick={() => onNavigate({ page: 'retrofit' })}
            title="Back to Retrofit Hub"
            className="p-2 rounded-md text-gray-700 hover:bg-gray-200 transition-colors"
          >
            <ArrowLeft size={22} />
          </button>
          <h1 className="text-lg font-semibold text-gray-800">
            RIR Diagram Plan Form
          </h1>
          <div className="w-10"></div> {/* Spacer */}
        </div>
      </header>

      {/* Content - TODO: Add form fields based on PDF */}
      <main className="flex-1 p-4 sm:p-6 lg:p-8">
        <h2>Room in Roof (RIR) Plan</h2>
        {floorPlanId && <p>Plan for Floor Plan ID: {floorPlanId}</p>}
        {/* Form elements for RIR plan */}
        <p>Details about Room in Roof Insulation...</p>
        <button onClick={() => onNavigate({ page: 'retrofit' })} className="mt-4 px-4 py-2 bg-gray-200 rounded">
          Back to Retrofit
        </button>
      </main>
    </div>
  );
};

export default RirPlan; 